<script>
    import {asgariUcret} from "./prices";
    import {numberFormat, moneyFormat} from "./utils";
    import {fly} from "svelte/transition"

    let index = 0
    let playing = true
    let loop = true

    $: current = asgariUcret[index]
    $: percent = ((current.price / current.dollar) / current.price) * 100

    function increment() {
        if (index < asgariUcret.length - 1) {
            index += 1
        } else {
            if (loop) {
                index = 0
            }
        }
    }

    function playToggle() {
        playing = !playing
    }

    function toggleLoop() {
        loop = !loop
    }

    let interval

    $: {
        if (playing) {
            interval = setInterval(increment, 1000)
        } else {
            clearInterval(interval)
        }
    }
</script>

<div class="box">
    <h3>
        <div class="key">YIL</div>
        <div class="value">
            {#key current.year}
                <span in:fly={{ y: -20 }} out:fly={{ y: 20 }}>
                    {current.year}
                </span>
            {/key}
        </div>
    </h3>

    <h3>
        <div class="key">Asgari Ücret</div>
        <div class="value">
            {#key current.price}
                <span in:fly={{ y: -20 }} out:fly={{ y: 20 }}>
                    {moneyFormat(current.price)}
                </span>
            {/key}
        </div>
    </h3>

    <h3>
        <div class="key">Dolar karşılığı</div>
        <div class="value">
            {#key current.price}
                <span in:fly={{ y: -20 }} out:fly={{ y: 20 }}>
                    {moneyFormat(current.price / current.dollar, 'USD')}
                </span>
            {/key}
        </div>
    </h3>
</div>

<div class="alim-gucu" style={`--width: ${percent}%`}>
    <h3>ALIM GÜCÜ</h3>
    <div>
        %{numberFormat(percent)}
    </div>
</div>

<div class="actions">
    <button class:active={playing} on:click={playToggle}>
        {#if playing}
            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor"  height="24" viewBox="0 0 24 24" width="24">
                <path d="M0 0h24v24H0V0z" fill="none"/>
                <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/>
            </svg>
        {:else}
            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor"  height="30" viewBox="0 0 24 24">
                <path d="M0 0h24v24H0V0z" fill="none"/>
                <path d="M10 8.64L15.27 12 10 15.36V8.64M8 5v14l11-7L8 5z"/>
            </svg>
        {/if}
    </button>
    <button class:active={loop} on:click={toggleLoop}>
        <svg xmlns="http://www.w3.org/2000/svg" height="24" fill="currentColor" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"/></svg>
    </button>
</div>

<style>
    .actions {
        position: fixed;
        bottom: 40px;
        right: 40px;
        z-index: 2;
        display: flex;
        align-items: center;
    }

    .actions button {
        margin-left: 10px;
        width: 60px;
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        cursor: pointer;
        border: none;
    }
    .actions button.active {
        color: #fff;
        background: orangered;
    }

    .box {
        position: absolute;
        top: 0;
        left: 0;
        padding: 50px;
        z-index: 1;
        display: grid;
        gap: 40px;
    }

    .box h3 .key {
        font-size: 24px;
        font-weight: normal;
        opacity: .5;
        margin-bottom: 10px;
        color: #fff;
    }

    .box h3 .value {
        font-size: 40px;
        font-weight: 900;
        color: #fff;
        height: 50px;
    }

    .box h3 .value span {
        position: absolute;
    }

    .alim-gucu {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        padding: 50px;
    }

    .alim-gucu::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: var(--width, 100%);
        height: 100%;
        z-index: -1;
        background: green;
        transition: 1s all;
    }

    .alim-gucu h3 {
        font-size: 50px;
        color: #fff;
        font-weight: 900;
        letter-spacing: 5px;
        margin-bottom: 10px;
    }

    .alim-gucu div {
        font-size: 30px;
        font-weight: 400;
        color: #fff;
        opacity: .5;
    }
</style>